<div class="row d-flex justify-content-center">
  <div class="col-12">
    <form [formGroup]="form" (ngSubmit)="changePassword()">
      <div class="row">
        
        <!-- ძველი პაროლი -->
        <div class="col-12 input-group mt-3">
          <div class="form-floating">
            <input 
              [type]="showOldPassword ? 'text' : 'password'" 
              class="form-control" 
              formControlName="oldPassword"  
              placeholder="{{ 'OLD_PASSWORD' | translate }}">
            <label for="oldPassword">{{ 'OLD_PASSWORD' | translate }}</label>
          </div>
          <span class="input-group-text cursor-pointer" (click)="toggleShowPassword('oldPassword')">
             <i class="fi" [ngClass]="showOldPassword ? 'fi-rr-eye' : 'fi-rr-eye-crossed' "></i>
          </span>
        </div>

        <!-- ახალი პაროლი -->
        <div class="col-12 input-group mt-3">
          <div class="form-floating">
            <input 
              [type]="showNewPassword ? 'text' : 'password'" 
              class="form-control" 
              formControlName="newPassword" 
              placeholder="{{ 'NEW_PASSWORD' | translate }}">
            <label for="newPassword">{{ 'NEW_PASSWORD' | translate }}</label>
          </div>
          <span class="input-group-text cursor-pointer" (click)="toggleShowPassword('newPassword')">
             <i class="fi" [ngClass]="showNewPassword ? 'fi-rr-eye' : 'fi-rr-eye-crossed' "></i>
          </span>
        </div>

        <!-- პაროლის სიძლიერის პროგრესი -->
        <div class="password-strength mt-2" *ngIf="isTyping">
          <div class="progress">
            <div class="progress-bar"
                 [ngClass]="{'bg-danger': passwordStrength <= 40, 
                             'bg-warning': passwordStrength > 40 && passwordStrength < 80, 
                             'bg-success': passwordStrength >= 80}"
                 [style.width.%]="passwordStrength">
            </div>
          </div>
          <small *ngIf="passwordStrength <= 40" class="text-danger">{{ 'VALIDATION.PASSWORD_STRENGTH_WEAK' | translate }}</small>
          <small *ngIf="passwordStrength > 40 && passwordStrength < 80" class="text-warning">{{ 'VALIDATION.PASSWORD_STRENGTH_MEDIUM' | translate }}</small>
          <small *ngIf="passwordStrength >= 80" class="text-success">{{ 'VALIDATION.PASSWORD_STRENGTH_STRONG' | translate }}</small>
        </div>

        <!-- გაიმეორეთ ახალი პაროლი -->
        <div class="col-12 input-group mt-3">
          <div class="form-floating">
            <input 
              [type]="showConfirmPassword ? 'text' : 'password'" 
              class="form-control" 
              formControlName="confirmPassword" 
              placeholder="{{ 'CONFIRM_NEW_PASSWORD' | translate }}">
            <label for="confirmPassword">{{ 'CONFIRM_NEW_PASSWORD' | translate }}</label>
          </div>
          <span class="input-group-text cursor-pointer" (click)="toggleShowPassword('confirmPassword')">
             <i class="fi" [ngClass]="showConfirmPassword ? 'fi-rr-eye' : 'fi-rr-eye-crossed' "></i>
          </span>
        </div>

        <!-- პაროლები არ ემთხვევა -->
        <p class="text-danger" 
           *ngIf="form.get('confirmPassword')?.hasError('mismatch') 
                  && form.get('confirmPassword')?.touched">
          {{ 'VALIDATION.PASSWORD_MISMATCH' | translate }}
        </p>
      </div>

      <!-- Submit Button -->
      <button type="submit" class="btn btn-lg btn-primary mt-3 mb-3" 
              [disabled]="isLoading || form.invalid || form.hasError('mismatch')">
        <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" ></span>
        {{ 'CHANGE' | translate }}
      </button>
    </form>
  </div>
</div>